import _ from "lodash";
import notificationStore from "./notifications";
import store from "../.";
import i18n from "../../utils/i18n";

// override getCounter from notificationStore
notificationStore.state.getCounter = (notifications, filtered = false) => {
  if (!filtered) notifications = periodFilter(notifications);

  let withCounter = notifications.filter((n) => n.messageData.UnreadCount);
  let counter = 0;
  withCounter.forEach((n) => (counter += n.messageData.UnreadCount));
  let withOutCounter = notifications.filter(
    (n) => !n.messageData.UnreadInfo
  ).length;
  return counter + withOutCounter;
};

function periodFilter(notifications) {
  const userInfo = store.getters["userinfoStore/getUserinfo"];
  if (!userInfo) return [];

  const period = store.getters["marsPeriodStoreArchived/getMarsPeriod"];

  // подбираются нотификации у которых есть период и он соответсвует выбранному или же периода нет в принципе
  let inPeriod = notifications.filter(n =>
    !(n?.messageData?.Record?.PeriodId || n?.messageData?.Period)
    || (n?.messageData?.Record?.PeriodId === period.id
        || (n?.messageData?.Period === true
            && Array.isArray(n?.messageData?.UnreadInfo)
            && n?.messageData?.UnreadInfo?.find(x => x.PeriodId === period.id)))
  );

  // создание нового объекта для дальнейшей фильтрации
  // если не делать копирование то меняется notificationStore.state
  // из-за чего перетираются данные
  // TODO: remove cloneDeep (?)
  inPeriod = _.cloneDeep(inPeriod);

  // подфильтровываются значения в групповых нотификациях по периоду
  let filterPeriod = inPeriod.filter(n => Array.isArray(n.messageData.UnreadInfo));
  filterPeriod.forEach(n => {
    n.messageData.UnreadInfo = n.messageData.UnreadInfo.filter(x => !x.PeriodId || x.PeriodId === period.id);
  });

  const isAgency = userInfo.agencyLinkType?.toLowerCase() === "agency";
  if (isAgency) {
    // если пользователь агент то необходимо подфильтровать нотификации по его агенству
    // выбираются либо нотификации без периода (не относящиеся к АП)
    // либо относящиеся к агенству пользователя
    // либо групповые
    inPeriod = inPeriod.filter(n =>
      !(n?.messageData?.Record?.PeriodId || n?.messageData?.Period)
      || (n.messageData.Record?.AgencyId === userInfo.agencyLinkAgencyId
          || n.messageData.UnreadInfo)
    );

    // фильтрация значений внутри групповых нотификаций
    let toFilter = inPeriod.filter(n => Array.isArray(n.messageData.UnreadInfo) && n.messageData.Period);
    toFilter = toFilter.map(n => {
      let ui = n.messageData.UnreadInfo;
      n.messageData.UnreadCount = 0;
      ui.forEach(info => {
        const actual = info.Aditional.filter(a => a.AgencyId === userInfo.agencyLinkAgencyId);
        info.Aditional = actual;
        const included = actual.map(a => a.Id);
        info.Ids = info.Ids.filter(id => included.includes(id));
      });
    });
  }

  // проставление счетчиков и дополнительных значений
  inPeriod
    .forEach(n => {
      if (n.messageData.UnreadInfo) {
        n.messageData.UnreadCount =
          Array.isArray(n.messageData.UnreadInfo)
            ? n.messageData.UnreadInfo[0]?.Ids?.length || 0
            : n.messageData.UnreadInfo.Ids.length;
      }
      if ((n?.messageData?.Record?.PeriodId === period.id
        || (n?.messageData?.Period === true
            && Array.isArray(n?.messageData?.UnreadInfo)
            && n?.messageData?.UnreadInfo?.find(x => x.PeriodId === period.id))))
      {
        n.periodId = period.id;
      }

      if (n.messageData.NotificationType === "orderStatusNotification") {
        let orderName = period.name;
        if (!isAgency)
          orderName += " " + n.messageData.Record.AgencyName;

        n.title = n.title.replace("{orderName}", orderName).replace("{status}", i18n.global.t("order_" + n.messageData.Record.Status));
      }
      else if (n.messageData.NotificationType && n.messageData.NotificationType.endsWith("OrderMarsStatus")  ||
        n.messageData.NotificationType === "orderNewStatus") {
          let orderName = n.messageData.PeriodName;
          n.title = n.title.replace("{orderName}", orderName);
      }
    })

  return inPeriod;
}

const getters = {
  notificationMessages: () => {
    const notifications = store.getters["notifications/notificationMessages"];
    return periodFilter(notifications);
  },
  lastChanged: () => {
    return store.getters["notifications/lastChanged"];
  },
};

const actions = {
  // пересчитывает каунтеры в пунктах меню для АП
  async recalculateMenu(context) {
    let notifications = context.getters.notificationMessages.filter(n => n.messageData.Title === "AddressProgramArchived" && n.readed === false);
    if (notifications && notifications.length > 0) {
      let first = notifications[0];
      first.counter = context.rootGetters["notifications/getCounter"](notifications, true);
      store.dispatch("notifications/updateLastChanged", first);
    } else {
      store.dispatch("notifications/updateLastChanged", {
        messageData: { Title: "AddressProgramArchived" },
        counter: 0
      });
    }
  },
  async updateReaded(context, info) {
    let toUpdate = context.getters.notificationMessages.filter(n => n.messageData.Title === info.title && n.readed === false);
    const period = store.getters["marsPeriodStoreArchived/getMarsPeriod"];
    let tasks = [];
    toUpdate.forEach(n => {
      let id = n.messageData.Record.Id;
      if (typeof id === "string" && id !== 'orderMarsStaticId') {
        let realIds = n.messageData.UnreadInfo.flatMap(x => x.Ids);
        let staticId = id;
        if (!id.includes("NewStaticId") && id.includes("StaticId")) {
          staticId = staticId.substring(0, id.length - "StaticId".length) + "NewStaticId";
        }

        // чтение групповой нотификации
        let t1 = store.dispatch("notifications/updateReadedRecord", {
          title: info.title,
          id: id,
          realIds: realIds,
          paramFilter: (x => x.PeriodId === period.id),
          skipRead: true,
          groupUpdate: true,
        });
        // чтение групповой нотификации (которая приходит при входе пользователя в систему - INotifier.SendPending())
        let t2 = staticId == id
          ? Promise.resolve()
          : store.dispatch("notifications/updateReadedRecord", {
              title: info.title,
              id: staticId,
              realIds: realIds,
              paramFilter: (x => x.PeriodId === period.id),
              skipRead: true,
              groupUpdate: true,
            });
        tasks.push(t1, t2);
      } else {
        // чтение одиночной нотификации
        let t = store.dispatch("notifications/updateReadedRecord", {
          title: info.title,
          id: Number(id),
        });
        tasks.push(t);
      }
    });

    await Promise.all(tasks);
  },
};

export default {
  namespaced: true,
  getters,
  actions,
};
